import { Archive, Copy, LoaderCircle, RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";
import { startupDiagnostics } from "../../lib/startupTelemetry.js";
import type { ResolvedLocale } from "../../app/locale.js";
import "./StartupScreen.css";

// This small recovery vocabulary must work even when the translation chunk fails.
const messages = {
  en: { loading: "Loading Home-EM…", slow: "This is taking longer than usual. Check your connection or try again.",
    error: "Home-EM could not finish loading.", retry: "Try again", copy: "Copy loading diagnostics", copied: "Copied", copyFailed: "Could not copy diagnostics" },
  es: { loading: "Cargando Home-EM…", slow: "Esto está tardando más de lo habitual. Revisa tu conexión o inténtalo de nuevo.",
    error: "Home-EM no pudo terminar de cargar.", retry: "Intentar de nuevo", copy: "Copiar diagnóstico de carga", copied: "Copiado", copyFailed: "No se pudo copiar el diagnóstico" }
};
const brand = "Home-EM";

export function StartupScreen({ locale, failed = false, embedded = false, onRetry }: { locale: ResolvedLocale; failed?: boolean; embedded?: boolean; onRetry: () => void }) {
  const [slow, setSlow] = useState(false);
  const [copyState, setCopyState] = useState<"copy" | "copied" | "copyFailed">("copy");
  useEffect(() => { const timer = setTimeout(() => setSlow(true), 5_000); return () => clearTimeout(timer); }, []);
  const text = messages[locale];
  const Container = embedded ? "section" : "main";
  return <Container className={`startup-screen${embedded ? " startup-screen-embedded" : ""}`}>
    <section className="startup-card" aria-busy={!failed} aria-labelledby="startup-title">
      <div className="auth-loading-mark" aria-hidden="true"><Archive size={26} />{!failed && <LoaderCircle className="spin" size={22} />}</div>
      <h1 id="startup-title">{brand}</h1>
      <p role={failed ? "alert" : "status"}>{failed ? text.error : slow ? text.slow : text.loading}</p>
      {(slow || failed) && <div className="startup-actions">
        <button type="button" className="primary" onClick={onRetry}><RefreshCw size={18} />{text.retry}</button>
        <button type="button" onClick={() => {
          if (!navigator.clipboard) { setCopyState("copyFailed"); return; }
          void navigator.clipboard.writeText(startupDiagnostics()).then(() => setCopyState("copied")).catch(() => setCopyState("copyFailed"));
        }}><Copy size={18} />{text[copyState]}</button>
      </div>}
    </section>
  </Container>;
}
